export default class User {
    static USER_NAMESPACES = {
        user: 'cwf-user',
        init: 'cwf-user-init',
    };

    static async init(propertyUser) {
        this.setUser({
            id: propertyUser.id,
            name: propertyUser.name,
            role: propertyUser.role__c,
            sfid: propertyUser.sfid,
            username: propertyUser.username__c,
        });
        localStorage.setItem(this.USER_NAMESPACES['init'], 1);
    }

    static isInit() {
        return localStorage.getItem(this.USER_NAMESPACES['init']) == 1;
    }

    static clear() {
        for (const value of Object.values(this.USER_NAMESPACES)) {
            localStorage.removeItem(value);
        }
    }

    static setUser(user) {
        localStorage.setItem(this.USER_NAMESPACES['user'], JSON.stringify(user));
    }

    static getUser() {
        return JSON.parse(localStorage.getItem(this.USER_NAMESPACES['user']));
    }

    static getToken() {
        return localStorage.getItem('cwf-token');
    }

    static async canViewPage(page) {
        const token = localStorage.getItem('cwf-token');
        return new Promise((resolve, reject) => {
            fetch(`${process.env.REACT_APP_PROXY_URL || ''}/api/page-permission/${page}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    resolve(data);
                })
                .catch((err) => reject(err));
        });
    }
}
